export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 5_16.66e4567c.jpg";